module.exports = __webpack_public_path__ + "img/Personenkraftwagen.7fa59a43.svg";